import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-下载",
  "use": "vab-icon-下载-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-下载\"><path d=\"M512 800 288 576h160V192h128v384h160z M224 832h576v96H224z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol